
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2141',
  depVersions: {
  "customer-portal-app": "static-1.2141",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.461",
  "data-fetching-client": "static-1.9628",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.428",
  "growth-payments-core": "static-1.25215",
  "head-dlb": "static-1.4938",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5547",
  "hs-test-utils": "static-1.7970",
  "hub-http": "static-1.6175",
  "hub-http-shared-msw-handlers": "static-1.9845",
  "hubspot-dlb": "static-2.1832",
  "hubspot-prosemirror": "static-1.18087",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11415",
  "I18n": "static-7.1611",
  "immutable": "static-2.77",
  "jasmine-runner": "static-1.6423",
  "payment-link-components": "static-1.23386",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6960",
  "quartz-core": "static-1.6179",
  "react": "static-7.185",
  "react-colorpicker": "static-2.10164",
  "react-dlb": "static-1.78",
  "react-utils": "static-2.5305",
  "rich-text-lib": "static-1.19744",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17915",
  "ui-components-test-utils": "static-1.5553",
  "UIComponents": "static-3.8362",
  "foundations-assets": "static-1.4810",
  "foundations-components": "static-1.7837",
  "foundations-theming": "static-1.4370",
  "foundations-theming-specialty": "static-1.2086",
  "framer-motion": "static-1.71",
  "metrics-js": "static-1.9542",
  "PortalIdParser": "static-2.388",
  "portals-platform-lib": "static-1.802",
  "quartz-config": "static-1.738",
  "quartz-routing": "static-1.390",
  "quick-fetch": "static-1.3878",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1-feature-id-1324-marker-timings.12",
  "rpc-client-utils": "static-1.4604",
  "sanitize-text": "static-1.8097",
  "styled-components": "static-2.88",
  "tanstack-table": "static-1.54",
  "ui-addon-draggable": "static-3.4723",
  "ui-addon-react-router-dom": "static-1.9499",
  "usage-tracker": "static-1.7292",
  "usage-tracker-anonymous": "static-1.5709",
  "usage-tracker-core": "static-1.7142",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3364",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3237",
  "quartz-webpack": "static-1.3184",
  "bend-plugin-quartz-routing": "static-1.38",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.81",
  "customer-data-objects": "static-1.7616",
  "frontend-preferences-client": "static-1.7881",
  "laboratory-lib": "static-3.7112",
  "onboarding-scopes": "static-1.6416",
  "ui-addon-opt": "static-4.8327",
  "HeadJS": "static-2.741",
  "hs-test-utils-bend-plugin": "static-1.3081",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "hs-locale-management": "static-1.45",
  "ts-schema": "static-1.4039",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7677",
  "cssUtils": "static-1.779",
  "customer-data-ui-utilities": "static-1.9780",
  "HubStyle": "static-2.11723",
  "knowledge-content-types": "static-1.8479",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.635",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.486",
  "ui-addon-emoji-picker": "static-1.9841",
  "ui-addon-i18n": "static-1.11104",
  "ui-business-units-lib": "static-1.9002",
  "ui-shepherd-react": "static-3.10102",
  "video-components-external": "static-1.11099",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4278",
  "commerce-tours-lib": "static-1.6001",
  "customer-data-properties": "static-1.51368",
  "getting-started-shared-tasks": "static-1.18350",
  "growth-onboarding-reliability": "static-1.5035",
  "onboarding-tours": "static-1.16504",
  "reference-resolvers-lite": "static-1.8048",
  "sales-checkout-service-client": "static-1.3593",
  "ui-addon-iframeable": "static-1.9008",
  "user-context": "static-1.5055",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.827",
  "hubspotter-http": "static-1.4613",
  "icons": "static-2.644",
  "mobile-manifest-mixins": "static-1.515",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.635",
  "quartz-head": "static-1.625",
  "quartz-test": "static-1.635",
  "quartz-tracking": "static-1.339",
  "ui-fonts": "static-1.677",
  "usage-tracker-container": "static-1.7282",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9382",
  "data-token-picker": "static-1.16317",
  "FileManagerLib": "static-1.39113",
  "property-translator": "static-1.5355",
  "atom": "static-1.5026",
  "merchandise-lib": "static-1.262",
  "purchase-motions-components": "static-1.5793",
  "salesImages": "static-1.524",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5320",
  "react-select-plus": "static-1.104",
  "react-virtualized": "static-2.98",
  "ui-images": "static-2.1140",
  "bend-plugin-foundations-components": "static-1.4106",
  "floating-ui": "static-1.55",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.10",
  "trellis-assets": "static-1.1691",
  "bend-plugin-foundations-theming": "static-1.2853",
  "foundations-theming-base": "static-1.3355",
  "stylex": "static-1.32",
  "interframe": "static-3.4715",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5706",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "web-vitals": "static-1.4",
  "bend-plugin-chirp-manifest": "static-1.14",
  "chirp-fetch": "static-1.1839",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4426",
  "react-flip-move": "static-1.69",
  "bender-build-tools": "static-1.3123",
  "inbound-db-properties-service-client": "static-1.3802",
  "superstore": "static-1.4720",
  "feedback-loader": "static-1.29206",
  "ai-components-ui-library": "static-1.8804",
  "ui-addon-video-player": "static-1.8652",
  "ui-coaching-tips": "static-1.28400",
  "sassPrefix": "static-1.155",
  "react-dnd-compat": "static-1.4574",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2452",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8124",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4602",
  "content-media-composition-data-lib": "static-1.12076",
  "content-media-compositions": "static-2.16083",
  "idb-keyval": "static-1.43",
  "immer": "static-1.33",
  "immerable": "static-1.4107",
  "magpie-lib": "static-1.5529",
  "magpie-types": "static-1.4989",
  "media-bridge-lib": "static-1.18840",
  "video-data-lib": "static-1.34757",
  "commerce-products-lib": "static-1.9337",
  "crm-message-bus": "static-1.42846",
  "growth-data-modal": "static-1.5350",
  "hubspot-apollo-client": "static-1.4830",
  "onboarding-tours-client": "static-1.4718",
  "calling-global-api": "static-1.64331",
  "calling-internal-common": "static-1.31255",
  "calling-lifecycle-internal": "static-1.65713",
  "calling-lifecycle-messages": "static-1.58007",
  "conditional-properties-service-client": "static-1.3758",
  "crm-links": "static-1.6236",
  "customer-data-objects-ui-components": "static-1.12979",
  "customer-data-properties-shared-msw-handlers": "static-1.9172",
  "customer-data-property-utils": "static-1.8037",
  "external-options-client-types": "static-1.4120",
  "file-manager-components": "static-1.23473",
  "framework-data-schema-resolvers": "static-1.6832",
  "google-libphonenumber": "static-1.37",
  "hs-resources": "static-1.99",
  "inbound-db-meta-service-client": "static-1.3552",
  "inbounddb-objects-service-types": "static-1.4185",
  "meetings-icalendar-utils-lib": "static-1.585",
  "multi-currency-client-types": "static-1.3653",
  "object-builder-ui-client": "static-1.48561",
  "pipeline-validation-client-types": "static-1.3927",
  "property-value-citations": "static-1.1982",
  "pulse": "static-1.511",
  "smart-property-lib": "static-1.6679",
  "tiered-pricing": "static-1.1105",
  "ui-addon-form-validation": "static-1.10942",
  "growth-onboarding-confetti": "static-1.3021",
  "growth-onboarding-next-action-utils": "static-1.1762",
  "navigation-components": "static-1.17859",
  "onboarding-tours-utils": "static-1.570",
  "ui-shepherd-tracker": "static-1.7483",
  "ui-universal-auth": "static-1.8916",
  "batch-promise": "static-1.1504",
  "navigation-messaging": "static-1.7186",
  "getting-started-shared-tasks-store": "static-1.17468",
  "hubspotter-http-shared-msw-handlers": "static-1.9843",
  "usage-tracker-session-replay": "static-1.4978",
  "audio-components": "static-1.5842",
  "FileManagerCore": "static-1.38972",
  "FileManagerImages": "static-1.36624",
  "video-components": "static-1.13102",
  "foundations-components-legacy": "static-1.862",
  "purchase-motions-api": "static-1.5796",
  "self-service-api": "static-1.10199",
  "signup-constants": "static-1.18749",
  "signup-ui-url-generator": "static-2.7992",
  "trials-service-types": "static-1.3857",
  "usage-tracker-public": "static-1.7103",
  "chatspot-core": "static-1.21046",
  "ContentUtils": "static-1.68212",
  "copilot-toolkit": "static-1.10982",
  "growth-onboarding-feedback-components": "static-1.6537",
  "reactive-lib": "static-1.675",
  "simple-logging-lib": "static-1.3003",
  "commerce-permissions": "static-1.719",
  "customer-data-tracking": "static-1.6839",
  "products-iframe-lib": "static-1.7776",
  "products-ui-components-shared-msw-handlers": "static-1.10227",
  "onboarding-data-sync-lib": "static-1.1880",
  "hubspot-apollo-cache": "static-1.289",
  "calling-error-reporting": "static-1.31261",
  "shared-worker-versioning": "static-1.10991",
  "calling-usage-tracker": "static-1.6496",
  "voice-sms-access-library": "static-1.780",
  "conversations-skeleton-state": "static-1.7202",
  "location-customization-utils-lib": "static-1.9091",
  "crm-pipelines-api-client-types": "static-1.4104",
  "framework-builder-read-service-client": "static-1.3971",
  "framework-data-schema-quick-fetch": "static-1.6737",
  "persist-promise": "static-1.3661",
  "bend-plugin-pulse": "static-1.14",
  "directed-graph": "static-1.889",
  "event-emitter": "static-1.902",
  "fast-json-patch": "static-1.62",
  "data-agent-kit": "static-1.116",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9928",
  "fsm": "static-1.3686",
  "policy-lib": "static-1.6726",
  "react-tinymce": "static-1.55094",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9991",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54220",
  "tinymce-plugins": "static-1.57334",
  "tinymce-themes": "static-1.56190",
  "growth-onboarding-next-action-components": "static-1.1790",
  "user-context-client": "static-1.4564",
  "nest": "static-1.181",
  "unified-auth-core-lib": "static-1.711",
  "amplitude-session-replay-browser": "static-1.59",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4485",
  "video-embed": "static-1.35591",
  "content-icons-ui": "static-1.2213",
  "social-insights-client-types": "static-1.21943",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4765",
  "integrations-lib": "static-1.15953",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4218",
  "InboxConnectUtils": "static-4.14656",
  "calling-orchestration-schema": "static-1.35557",
  "crm-record-cards-service-types": "static-1.3572",
  "highcharts": "static-8.103",
  "trellis-story-utils": "static-1.4469",
  "storybook-react": "static-1.32",
  "hub-http-contrib": "static-1.2994",
  "tinymce-data": "static-1.40305",
  "ui-addon-sales-email": "static-1.5164",
  "codemirror": "static-5.94",
  "layout-dnd-components": "static-1.12348",
  "layout-dnd-utils": "static-1.11323",
  "react-codemirror": "static-1.10577",
  "ui-brand-identity-lib": "static-1.15018",
  "NamespacedHubStyle": "static-2.9024",
  "outpost": "static-1.4142",
  "flux-actions": "static-1.331",
  "integrations-error-boundary-lib": "static-1.13368",
  "integrations-tracking-lib": "static-1.5552",
  "native-integrations-shared-strings": "static-1.7737",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10325",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.430",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68287",
  "layout-data-lib": "static-1.9648",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2966",
  "google-sheets-integration-lib": "static-1.84",
  "microsoft-drive-integration-lib": "static-1.196",
  "advanced-menus-core": "static-1.15050",
  "advanced-menus-lib": "static-1.12002",
  "ExportDialog": "static-6.10347",
  "ui-memberships-settings-lib": "static-1.33904",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15049",
  "simple-menus-lib": "static-1.16566"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2141",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.461",
  "data-fetching-client": "/data-fetching-client/static-1.9628",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.428",
  "growth-payments-core": "/growth-payments-core/static-1.25215",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5547",
  "hs-test-utils": "/hs-test-utils/static-1.7970",
  "hub-http": "/hub-http/static-1.6175",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9845",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18087",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11415",
  "I18n": "/I18n/static-7.1611",
  "immutable": "/immutable/static-2.77",
  "jasmine-runner": "/jasmine-runner/static-1.6423",
  "payment-link-components": "/payment-link-components/static-1.23386",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6960",
  "quartz-core": "/quartz-core/static-1.6179",
  "react": "/react/static-7.185",
  "react-colorpicker": "/react-colorpicker/static-2.10164",
  "react-dlb": "/react-dlb/static-1.78",
  "react-utils": "/react-utils/static-2.5305",
  "rich-text-lib": "/rich-text-lib/static-1.19744",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17915",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5553",
  "UIComponents": "/UIComponents/static-3.8362",
  "foundations-assets": "/foundations-assets/static-1.4810",
  "foundations-components": "/foundations-components/static-1.7837",
  "foundations-theming": "/foundations-theming/static-1.4370",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2086",
  "framer-motion": "/framer-motion/static-1.71",
  "metrics-js": "/metrics-js/static-1.9542",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "portals-platform-lib": "/portals-platform-lib/static-1.802",
  "quartz-config": "/quartz-config/static-1.738",
  "quartz-routing": "/quartz-routing/static-1.390",
  "quick-fetch": "/quick-fetch/static-1.3878",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1-feature-id-1324-marker-timings.12",
  "rpc-client-utils": "/rpc-client-utils/static-1.4604",
  "sanitize-text": "/sanitize-text/static-1.8097",
  "styled-components": "/styled-components/static-2.88",
  "tanstack-table": "/tanstack-table/static-1.54",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4723",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9499",
  "usage-tracker": "/usage-tracker/static-1.7292",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5709",
  "usage-tracker-core": "/usage-tracker-core/static-1.7142",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3364",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3237",
  "quartz-webpack": "/quartz-webpack/static-1.3184",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.38",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.81",
  "customer-data-objects": "/customer-data-objects/static-1.7616",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7881",
  "laboratory-lib": "/laboratory-lib/static-3.7112",
  "onboarding-scopes": "/onboarding-scopes/static-1.6416",
  "ui-addon-opt": "/ui-addon-opt/static-4.8327",
  "HeadJS": "/HeadJS/static-2.741",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3081",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "hs-locale-management": "/hs-locale-management/static-1.45",
  "ts-schema": "/ts-schema/static-1.4039",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7677",
  "cssUtils": "/cssUtils/static-1.779",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9780",
  "HubStyle": "/HubStyle/static-2.11723",
  "knowledge-content-types": "/knowledge-content-types/static-1.8479",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.635",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9841",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11104",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9002",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10102",
  "video-components-external": "/video-components-external/static-1.11099",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4278",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6001",
  "customer-data-properties": "/customer-data-properties/static-1.51368",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18350",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5035",
  "onboarding-tours": "/onboarding-tours/static-1.16504",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8048",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3593",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9008",
  "user-context": "/user-context/static-1.5055",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.827",
  "hubspotter-http": "/hubspotter-http/static-1.4613",
  "icons": "/icons/static-2.644",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.515",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.635",
  "quartz-head": "/quartz-head/static-1.625",
  "quartz-test": "/quartz-test/static-1.635",
  "quartz-tracking": "/quartz-tracking/static-1.339",
  "ui-fonts": "/ui-fonts/static-1.677",
  "usage-tracker-container": "/usage-tracker-container/static-1.7282",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9382",
  "data-token-picker": "/data-token-picker/static-1.16317",
  "FileManagerLib": "/FileManagerLib/static-1.39113",
  "property-translator": "/property-translator/static-1.5355",
  "atom": "/atom/static-1.5026",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "purchase-motions-components": "/purchase-motions-components/static-1.5793",
  "salesImages": "/salesImages/static-1.524",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5320",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-virtualized": "/react-virtualized/static-2.98",
  "ui-images": "/ui-images/static-2.1140",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4106",
  "floating-ui": "/floating-ui/static-1.55",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.10",
  "trellis-assets": "/trellis-assets/static-1.1691",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2853",
  "foundations-theming-base": "/foundations-theming-base/static-1.3355",
  "stylex": "/stylex/static-1.32",
  "interframe": "/interframe/static-3.4715",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5706",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "web-vitals": "/web-vitals/static-1.4",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.14",
  "chirp-fetch": "/chirp-fetch/static-1.1839",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4426",
  "react-flip-move": "/react-flip-move/static-1.69",
  "bender-build-tools": "/bender-build-tools/static-1.3123",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3802",
  "superstore": "/superstore/static-1.4720",
  "feedback-loader": "/feedback-loader/static-1.29206",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8804",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8652",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28400",
  "sassPrefix": "/sassPrefix/static-1.155",
  "react-dnd-compat": "/react-dnd-compat/static-1.4574",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2452",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8124",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4602",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12076",
  "content-media-compositions": "/content-media-compositions/static-2.16083",
  "idb-keyval": "/idb-keyval/static-1.43",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4107",
  "magpie-lib": "/magpie-lib/static-1.5529",
  "magpie-types": "/magpie-types/static-1.4989",
  "media-bridge-lib": "/media-bridge-lib/static-1.18840",
  "video-data-lib": "/video-data-lib/static-1.34757",
  "commerce-products-lib": "/commerce-products-lib/static-1.9337",
  "crm-message-bus": "/crm-message-bus/static-1.42846",
  "growth-data-modal": "/growth-data-modal/static-1.5350",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4830",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4718",
  "calling-global-api": "/calling-global-api/static-1.64331",
  "calling-internal-common": "/calling-internal-common/static-1.31255",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65713",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58007",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3758",
  "crm-links": "/crm-links/static-1.6236",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12979",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9172",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8037",
  "external-options-client-types": "/external-options-client-types/static-1.4120",
  "file-manager-components": "/file-manager-components/static-1.23473",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6832",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "hs-resources": "/hs-resources/static-1.99",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3552",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4185",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.585",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3653",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48561",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3927",
  "property-value-citations": "/property-value-citations/static-1.1982",
  "pulse": "/pulse/static-1.511",
  "smart-property-lib": "/smart-property-lib/static-1.6679",
  "tiered-pricing": "/tiered-pricing/static-1.1105",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10942",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3021",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1762",
  "navigation-components": "/navigation-components/static-1.17859",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.570",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7483",
  "ui-universal-auth": "/ui-universal-auth/static-1.8916",
  "batch-promise": "/batch-promise/static-1.1504",
  "navigation-messaging": "/navigation-messaging/static-1.7186",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17468",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9843",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4978",
  "audio-components": "/audio-components/static-1.5842",
  "FileManagerCore": "/FileManagerCore/static-1.38972",
  "FileManagerImages": "/FileManagerImages/static-1.36624",
  "video-components": "/video-components/static-1.13102",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.862",
  "purchase-motions-api": "/purchase-motions-api/static-1.5796",
  "self-service-api": "/self-service-api/static-1.10199",
  "signup-constants": "/signup-constants/static-1.18749",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7992",
  "trials-service-types": "/trials-service-types/static-1.3857",
  "usage-tracker-public": "/usage-tracker-public/static-1.7103",
  "chatspot-core": "/chatspot-core/static-1.21046",
  "ContentUtils": "/ContentUtils/static-1.68212",
  "copilot-toolkit": "/copilot-toolkit/static-1.10982",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6537",
  "reactive-lib": "/reactive-lib/static-1.675",
  "simple-logging-lib": "/simple-logging-lib/static-1.3003",
  "commerce-permissions": "/commerce-permissions/static-1.719",
  "customer-data-tracking": "/customer-data-tracking/static-1.6839",
  "products-iframe-lib": "/products-iframe-lib/static-1.7776",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10227",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1880",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.289",
  "calling-error-reporting": "/calling-error-reporting/static-1.31261",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10991",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6496",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.780",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7202",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9091",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4104",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3971",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6737",
  "persist-promise": "/persist-promise/static-1.3661",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.14",
  "directed-graph": "/directed-graph/static-1.889",
  "event-emitter": "/event-emitter/static-1.902",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "data-agent-kit": "/data-agent-kit/static-1.116",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9928",
  "fsm": "/fsm/static-1.3686",
  "policy-lib": "/policy-lib/static-1.6726",
  "react-tinymce": "/react-tinymce/static-1.55094",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9991",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54220",
  "tinymce-plugins": "/tinymce-plugins/static-1.57334",
  "tinymce-themes": "/tinymce-themes/static-1.56190",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1790",
  "user-context-client": "/user-context-client/static-1.4564",
  "nest": "/nest/static-1.181",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.711",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4485",
  "video-embed": "/video-embed/static-1.35591",
  "content-icons-ui": "/content-icons-ui/static-1.2213",
  "social-insights-client-types": "/social-insights-client-types/static-1.21943",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4765",
  "integrations-lib": "/integrations-lib/static-1.15953",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4218",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14656",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35557",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3572",
  "highcharts": "/highcharts/static-8.103",
  "trellis-story-utils": "/trellis-story-utils/static-1.4469",
  "storybook-react": "/storybook-react/static-1.32",
  "hub-http-contrib": "/hub-http-contrib/static-1.2994",
  "tinymce-data": "/tinymce-data/static-1.40305",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5164",
  "codemirror": "/codemirror/static-5.94",
  "layout-dnd-components": "/layout-dnd-components/static-1.12348",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11323",
  "react-codemirror": "/react-codemirror/static-1.10577",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15018",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9024",
  "outpost": "/outpost/static-1.4142",
  "flux-actions": "/flux-actions/static-1.331",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13368",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5552",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7737",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10325",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.430",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68287",
  "layout-data-lib": "/layout-data-lib/static-1.9648",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2966",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.84",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.196",
  "advanced-menus-core": "/advanced-menus-core/static-1.15050",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12002",
  "ExportDialog": "/ExportDialog/static-6.10347",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33904",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15049",
  "simple-menus-lib": "/simple-menus-lib/static-1.16566"
}
};
